import React, { useEffect, useState } from 'react'
import MessageAlert from '../../components/tools/MessageAlert'
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom'
import { useForm } from '../../hooks/ useForm';
import { startRegisterWithEmailPasswordName } from '../../helpers/auth';

const RegisterView = () => {
    const dispatch = useDispatch();
    const [errorLogin, setErrorLogin] = useState(false)
    const [messageError, setMessageError] = useState('')
    const [formValues, handleInputChange] = useForm({name: '', codigo: '', password: '', password2: ''});
    const {name, codigo, password,password2} = formValues;


    const handleRegister  = (e) => {
        e.preventDefault();
        if (isFormValid()) {
            let correo = codigo+'@unibague.edu.co';
            dispatch(startRegisterWithEmailPasswordName(correo, password, name))
        }
    }


    const isFormValid = ( ) =>{
        if (name.trim().length === 0) {
            setErrorLogin(true)
            setMessageError('Nombre requerido')
            return false
        }
        if (codigo.trim().length === 0) {
            setErrorLogin(true)
            setMessageError('Codigo requerido')
            return false
        }else if (password !== password2 || password.length < 5) {
            setErrorLogin(true)
            setMessageError('Contraseña invalida')
            return false
        }

        return true;
    }
    
    useEffect(() => {
        setTimeout(() => {
            setErrorLogin(false)
            setMessageError('')
        },10000)
        return () => {}
    }, [errorLogin])

    return (
        <div className='auth_contenedor'>
            <div className='contenedor_login'>
                <div className='contenedor_login_header'>
                    <h1 className='title'>Registrarse</h1>
                </div>
                <div className='contenedor_inputs'>
                    <form onSubmit={handleRegister}>
                        <div className='group_inputs'>
                            <input 
                                placeholder="Nombre"
                                type="text"
                                name="name"
                                value={name}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className='group_inputs'>
                            <input 
                                placeholder="Usuario"
                                type="text"
                                name="codigo"
                                value={codigo}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className='group_inputs'>
                            <input 
                                placeholder="Contraseña"
                                type="password"
                                name="password"
                                value={password}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className='group_inputs'>
                            <input 
                                placeholder="Ingrese Nuevamente la contraseña"
                                type="password"
                                name="password2"
                                value={password2}
                                onChange={handleInputChange}
                            />
                        </div>
                        { errorLogin && <MessageAlert alert='dan' msg={messageError} /> }
                        <button className='btn btn_info' type="submit">Iniciar Sesión</button>
                        <div className='group_links'>
                            <Link to="/auth/login">Ya tengo cuenta</Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default RegisterView
